<!-- 网站首页 -->
<template>
  <div class="index">
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <div
      style="min-width: 1380px;background-color: #f0f0f0;"
      class="carouserTwo"
    >
      <el-carousel
        :interval="4000"
        type="card"
        height="530px"
        arrow="never"
        :autoplay="true"
        class="custom-carousel"
      >
        <el-carousel-item
          v-for="(item, key) in CarouselChart"
          :key="item.id"
          :style="getItemStyle(key)"
        >
          <img style="width: 100%; height: 100%" :src="item.file.url" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div style="width: 100%;height: 300px;background-color: #f0f0f0;">
      <div
        style="width: 70%; height: 100%; margin: 0 auto;display: flex;justify-content: space-between;align-items: center;gap: 10px;"
      >
        <div class="custom-arrow buts" @click="prev">
          <img
            class="custom-arrow buts"
            src="../assets/newImage/组 20.png"
            alt=""
          />
        </div>
        <div
          class="carousel-track"
          @mouseenter="stopAutoPlay"
          @mouseleave="startAutoPlay"
          style="flex: 1; height: 100%; display: flex;align-items: center; overflow: hidden;white-space: nowrap;gap:25px"
        >
          <div
            v-for="(res, idx) in doubledData"
            :key="idx"
            :style="{
              transform: 'translateX(' + left + 'px)',
              transition: isTransition ? 'transform 0.6s ease' : 'none'
            }"
            style="width: 228px;height: 214px; flex: 0 0 calc(91.3% / 5); display: flex; flex-direction: column; align-items: center;gap: 10px; box-sizing: border-box;"
          >
            <div
              style="width: 100%;height: 172px; box-shadow: 8px 8px 0 0 #FFB903;border-radius: 25px;position: relative; box-sizing: border-box;"
            >
              <img
                style="width: 100%;height: 172px; border-radius: 25px;"
                fit="cover"
                :src="'api' + res.img"
                :hide-on-click-modal="true"
                preview-teleported
                :scroll-container="layout"
              />
              <img
                style="width: 52px; height: 52px;position: absolute;top: 36%; left: 40%;"
                src="../assets/newImage/矢量智能对象31.png"
                alt=""
                class="buts"
                @click="bofang('api' + res.tb_school_shiping)"
              />
            </div>
            <div
              class="buts"
              style="width: 80%; height: 42px;"
              @click="browse(res.tb_school_uuid)"
            >
              <div
                style="font-weight: 700;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                {{ res.name }}
              </div>
              <div
                style="font-size: 12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                {{ res.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="custom-arrow buts" @click="next">
          <img
            class="custom-arrow"
            src="../assets/newImage/组 20 (1).png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- <div class="box_102 box_101">
      <div class="group_48 flex-col">
        <div class="ping block_2 flex-col" style="position:relative;">
          <div class="lunbo">
            <div class="custom-arrow buts" @click="prev">
              <img
                class="custom-arrow buts"
                src="../assets/newImage/组 20.png"
                alt=""
              />
            </div>
            <el-carousel
              ref="myCarousel"
              :height="'250px'"
              indicator-position="none"
              arrow="never"
              style="flex: 1;"
              :autoplay="false"
            >
              <el-carousel-item
                v-for="(item, index) in shipinList"
                :key="index"
                style="width: 100%; height: 100%; display: grid;grid-template-columns: repeat(5,1fr);gap: 10px;"
              >
                <div
                  v-for="(res, idx) in item"
                  :key="idx"
                  style="width: 228px;height: 172px; display: flex; flex-direction: column; align-items: center;gap: 10px; box-sizing: border-box;"
                >
                  <div
                    style="width: 100%;height: 172px; box-shadow: 8px 8px 0 0 #FFB903;border-radius: 25px;position: relative; box-sizing: border-box;"
                  >
                    <img
                      style="width: 100%;height: 172px; border-radius: 25px;"
                      fit="cover"
                      :src="'api' + res.img"
                      :hide-on-click-modal="true"
                      preview-teleported
                      :scroll-container="layout"
                    />
                    <img
                      style="width: 52px; height: 52px;position: absolute;top: 36%; left: 40%;"
                      src="../assets/newImage/矢量智能对象31.png"
                      alt=""
                      class="buts"
                      @click="bofang('api' + item.tb_school_shiping)"
                    />
                  </div>
                  <div
                    class="buts"
                    style="width: 80%; height: 42px;"
                    @click="browse(res.tb_school_uuid)"
                  >
                    <div
                      style="font-weight: 700;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ res.name }}
                    </div>
                    <div
                      style="font-size: 12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ res.name }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="custom-arrow buts" @click="next">
              <img
                class="custom-arrow"
                src="../assets/newImage/组 20 (1).png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="box_102">
      <div class="section_14 flex-col">
        <div style="width: 100%;">
          <div
            style="text-align: left;width: 360px;height: 70px;font-family: FZLanTingHei-B-GBK;font-weight: 400;font-size: 100px;color: #F35022;opacity: 0.16;margin-left: -8px;"
          >
            Region
          </div>
          <h1 style="text-align: left;">区域搜索</h1>
        </div>
        <div
          style="width: 100%;display: grid; grid-template-columns: repeat(2, 1fr); gap: 30px"
        >
          <div
            style="display: grid; grid-template-columns: repeat(4, 1fr);gap: 10px; margin: 25px 0px 10px 0px;"
          >
            <div
              class="buts"
              v-for="(type, index) in schoolType"
              :key="type.value"
              :class="getNewTagClass(index)"
              :style="{
                padding: '10px',
                borderRadius: '15px',
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center'
              }"
              @click="toSchoolClass(type.value)"
            >
              <div>{{ type.label }}</div>
              <img
                style="width: 18px; height: 18px;"
                src="../assets/newImage/矢量智能对象.png"
                alt=""
              />
            </div>
          </div>
          <div
            class="Search buts"
            style="width: 100%; margin: 25px 0px 10px 0px; box-sizing: border-box;"
          >
            <el-input
              placeholder="请输入内容"
              v-model="kb_content"
              @keyup.enter.native="getAllKb"
            >
              <el-button slot="prepend" icon="el-icon-search" />
              <el-button slot="append" @click="search(kb_content)"
                >搜索</el-button
              >
            </el-input>
          </div>
        </div>
        <div class="schoolContent">
          <div>
            <div class="schoolMap">
              <img
                style="position: absolute; left: 45px; top: 20px;"
                src="../assets/newImage/地图.png"
                alt=""
              />
              <div class="count">
                <div style="font-size: 32px; font-weight: 700;">
                  {{ count }}
                </div>
                <div style="font-size: 14px;">全部地区学校数量</div>
              </div>
              <!-- 左上 -->
              <div
                style="position: absolute; top: 200px; left: 0px; display: flex; justify-content: space-evenly; gap: 10px; width: 500px;"
              >
                <div
                  style=" display: grid; grid-template-columns: repeat(2, 1fr);margin-top: 80px; gap: 10px; box-sizing: border-box;"
                >
                  <div
                    class="buts"
                    v-for="e in getMapAddList(106)"
                    :key="e.id"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-between;"
                    @click="district(106, e.id)"
                  >
                    <div
                      style="flex: 1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ e.label }}
                    </div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #A53462;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
                <div style="margin-top: 40px;">
                  <div
                    class="buts"
                    v-for="a in getMapAddList(104)"
                    :key="a.id"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-evenly; margin-top: 10px;"
                    @click="district(104, a.id)"
                  >
                    <div>{{ a.label }}</div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #F573AE;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  style=" display: grid; grid-template-columns: repeat(2, 1fr);margin-bottom: 90px; gap: 0px; box-sizing: border-box;"
                >
                  <div
                    class="buts"
                    v-for="v in getMapAddList(107, [
                      10704,
                      10706,
                      10707,
                      10703,
                      10709,
                      10708
                    ])"
                    :key="v.id"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-evenly;"
                    @click="district(107, v.id)"
                  >
                    <div>{{ v.label }}</div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #80BB03;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <!-- 下 -->
              <div
                style="position: absolute; bottom: 20px; left: 135px; display: flex; justify-content: space-evenly; width: 500px;"
              >
                <div
                  style=" display: grid; grid-template-columns: repeat(2, 1fr); box-sizing: border-box; margin-bottom: 55px;"
                >
                  <div
                    class="buts"
                    v-for="e in getMapAddList(108)"
                    :key="e.id"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-evenly;margin-top: 10px;"
                    @click="district(108, e.id)"
                  >
                    <div>{{ e.label }}</div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #C36045; padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  style="display: grid; grid-template-columns: repeat(2, 1fr);  box-sizing: border-box; gap: 10px;"
                >
                  <div
                    class="buts"
                    v-for="g in getMapAddList(105)"
                    :key="g.id"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-evenly;"
                    @click="district(105, g.id)"
                  >
                    <div
                      style="flex: 1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ g.label }}
                    </div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #FFB903;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
                <div>
                  <div
                    class="buts"
                    v-for="v in getMapAddList(107, [10705, 10701, 10700])"
                    :key="v.id"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-evenly; margin-bottom: 10px;"
                    @click="district(107, v.id)"
                  >
                    <div>{{ v.label }}</div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #80BB03;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <!-- 右 -->
              <div
                style="position: absolute; top: 90px; right: -15px; display: flex; flex-direction: column; justify-content: space-between; height: 70%;"
              >
                <div
                  style=" display: grid; grid-template-columns: repeat(1, 1fr); box-sizing: border-box;"
                >
                  <div
                    class="buts"
                    v-for="l in getMapAddList(100)"
                    :key="l.id"
                    style="width: 100px;display: flex; align-items: center; justify-content: space-between;margin-top: 10px; margin-left: 80px;"
                    @click="district(100, l.id)"
                  >
                    <div
                      style="flex: 1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ l.label }}
                    </div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #F35022; padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  style=" display: grid; grid-template-columns: repeat(2, 1fr); box-sizing: border-box; margin-right: 30px; margin-top: 30px"
                >
                  <div
                    class="buts"
                    v-for="e in getMapAddList(101)"
                    :key="e.id"
                    @click="district(101, e.id)"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-evenly;margin-top: 10px;"
                  >
                    <div>{{ e.label }}</div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #03A5F0; padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  style="display: grid; grid-template-columns: repeat(2, 1fr);  box-sizing: border-box; gap: 10px; margin-right: 40px;"
                >
                  <div
                    class="buts"
                    v-for="a in getMapAddList(102)"
                    :key="a.id"
                    style="width: 80px;display: flex; align-items: center; justify-content: space-evenly;"
                    @click="district(102, a.id)"
                  >
                    <div
                      style="flex: 1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >
                      {{ a.label }}
                    </div>
                    <img
                      style="width: 20px; height: 20px;  background-color: #00A199;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                      src="../assets/newImage/矢量智能对象.png"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="buts"
                  v-for="j in getMapAddList(103)"
                  :key="j.id"
                  style="width: 80px;display: flex; align-items: center; justify-content: space-evenly;margin-top: 10px;"
                  @click="district(103, j.id)"
                >
                  <div>{{ j.label }}</div>
                  <img
                    style="width: 20px; height: 20px;  background-color: rgb(212 41 168); padding: 5px; border-radius: 50%;box-sizing: border-box;"
                    src="../assets/newImage/矢量智能对象.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="hotKeywords">
              <div class="text-group_76 flex-col justify-between">
                <span class="text_23" style="font-weight: 700;font-size: 26px;"
                  >热门关键词查找学校</span
                >
                <span class="text_24">人気キーワードで検索</span>
              </div>
              <div class="box_53">
                <div
                  class="group_11 buts"
                  v-for="(item, index) in rmdqList"
                  :key="index"
                  @click="address(2, item)"
                >
                  <div style="font-weight: 700;">{{ item.tb_hxts_name }}</div>
                  <img
                    style="width: 20px; height: 20px;  background-color: #FFB903;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                    src="../assets/newImage/矢量智能对象.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="schoolSubjectOfATalk">
            <div
              class="text-group_77 flex-col justify-between"
              style="margin-bottom: 10px;"
            >
              <span class="text_32">话题学校</span>
              <span class="text_33">話題学校</span>
            </div>
            <VirtualList
              class="buts"
              style="flex: 1;"
              :data-sources="huatixxList"
              :size="120"
              :keeps="10"
              :data-key="'id'"
              :height="600"
              :auto-scroll="true"
              :scroll-interval="300"
              :scroll-step="1"
            >
              <template v-slot="{ item, index }">
                <div
                  style="height: 120px; margin: 4px; border-radius: 25px;box-shadow: 8px 8px 0 0 #FFB903;"
                  @click="browse(item.tb_school_uuid)"
                >
                  <!-- <p>{{ item.name }}</p> -->
                  <img
                    :src="'api' + item.tb_school_card_url"
                    alt=""
                    style="height: 100%;width:100%; border-radius: 25px;"
                  />
                </div>
              </template>
            </VirtualList>
          </div>
        </div>
      </div>
    </div>

    <div class="box_101" style="margin-top: 20px;">
      <div class="box_10 flex-row">
        <div class="section_33 flex-col">
          <div class="block_14 flex-row justify-between">
            <div class="image-text_78 flex-row justify-between">
              <h2>按地区检索学校</h2>
              <span class="text-group_211"
                >(注，勾选要查看的地区，无需选择上级地区)</span
              >
            </div>
          </div>
          <el-cascader-panel
            ref="cascader"
            class="thumbnail_151"
            style="border: none;"
            v-model="dd"
            :options="yjlist"
            :props="props"
            :collapse-tags="false"
            clearable
          ></el-cascader-panel>
          <el-button
            type="primary"
            style="width: 120px;height: 42px;background-color: rgba(230, 0, 33, 1);margin-top: 40px; margin-left: 20px;background-color: #F35022;border-radius: 15px;"
            @click="looook"
            >查询学校</el-button
          >
        </div>
        <div class="group_55">
          <h2 style="text-align: left;color: #fff;">
            热门城市
          </h2>
          <div
            class="rm"
            style="display: grid; grid-template-columns: repeat(4, 1fr);"
          >
            <div
              class="buts"
              v-for="(item, index) in dqList"
              :key="index"
              @click="address(1, item)"
            >
              <div
                style="display: flex;justify-content: space-between; align-items: center;"
              >
                <div>{{ item.tb_address_name }}</div>
                <img
                  style="width: 20px; height: 20px;  background-color: #F35022;padding: 5px; border-radius: 50%;box-sizing: border-box;"
                  src="../assets/newImage/矢量智能对象.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <h2 style="text-align: left;color: #fff;">特色</h2>
          <div
            class="rm"
            style="display: grid; grid-template-columns: repeat(3, 1fr);gap: 10px !important;"
          >
            <div
              v-for="(item, index) in tsList"
              :key="index"
              :class="getTagClass(index)"
              class="tag-item buts"
            >
              <span @click="address(2, item)">{{ item.tb_hxts_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box_102" style="width: 100%;">
      <div style="width: 1220px;margin: 10px auto;">
        <div style="position: relative;">
          <div
            style="text-align: left;width: 360px;height: 93px;font-family: FZLanTingHei-B-GBK;font-weight: 400;font-size: 100px;color: #F35022;opacity: 0.16;margin-left: -8px;"
          >
            Information
          </div>
          <div
            style="width: 100%; display: flex; justify-content: space-between; align-items: center; position: absolute;bottom: -28px;"
          >
            <h1>留学资讯</h1>
            <div
              style="display: grid; grid-template-columns: repeat(5, 1fr);gap: 10px; margin: 20px 0px 10px 0px;"
            >
              <div
                class="buts"
                v-for="(type, index) in newType"
                :key="type.value"
                style=" padding: 10px 30px; border-radius: 8px 8px 8px 8px;"
                :class="getNewTagClass(index)"
                @click="changeHotNewsType(type.value)"
              >
                {{ type.label }}
              </div>
            </div>
          </div>
        </div>
        <div
          style="width: 100%; margin-top: 40px; display: flex; gap: 30px; overflow-x: scroll;"
        >
          <div
            class="buts"
            @click.stop="information(item.tb_uuid)"
            v-for="(item, index) in hotNewsList"
            :key="index"
            style="width: 278px; height: 348px;display: flex; flex-direction: column; justify-content: space-between;gap: 5px; border-radius: 15px;padding-bottom: 20px;"
          >
            <img
              style="width: 285px; height: 180px;box-shadow: 8px 8px 0 0 #FFB903; border-radius: 15px;"
              :src="'api' + item.tb_home_img"
              alt=""
            />
            <div class="text-group_71 buts">
              {{ (item.tb_add_time || "").split("T")[0] }}
            </div>
            <div
              style="text-align: left; font-weight: 700; overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              v-html="item.tb_title"
            ></div>
            <img
              style="width: 26px; height: 26px;  background-color: #F35022;padding: 5px; border-radius: 50%;box-sizing: border-box;"
              src="../assets/newImage/矢量智能对象.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="box_102" style="width: 1220px; height: 240px;">
      <img
        style="width: 100%; height: 100%;"
        src="../assets/newImage/组 21.png"
        alt=""
      />
    </div>

    <div class="box_102" style="width: 1220px;margin: 10px auto;">
      <div style="position: relative;">
        <div
          style="text-align: left;width: 360px;height: 101px;font-family: FZLanTingHei-B-GBK;font-weight: 400;font-size: 100px;color: #F35022;opacity: 0.16;margin-left: -8px;"
        >
          News
        </div>
        <div
          style="width: 100%; display: flex; justify-content: space-between; align-items: center; position: absolute;bottom: -10px;"
        >
          <h1>最新新闻</h1>
        </div>
      </div>
      <div style="width: 100%; margin-top: 40px;">
        <div style="width: 100%; display: flex; gap: 5px;margin-left: 20px;">
          <div
            class="buts"
            v-for="(type, index) in newType"
            :key="type.value"
            style=" padding: 10px 30px; border-radius: 8px 8px 0px 0px;"
            :class="getTagClass(index)"
            @click="changeNewsType(type.value)"
          >
            {{ type.label }}
          </div>
        </div>
        <div
          style="width: 100%; padding: 20px; box-sizing: border-box; border: 3px solid #03A5F0;border-radius: 15px;"
        >
          <div
            v-for="news in newsList"
            :key="news.id"
            class="news buts"
            @click="getzxxq(news.tb_uuid)"
          >
            <div style="text-align: left;">
              <div style="font-weight: 700;margin-bottom: 5px;">
                {{ news.tb_title }}
              </div>
              <div style="color: rgba(102, 102, 102, 0.7);">
                {{ news.tb_add_time }}
              </div>
            </div>
            <div class="newsBtn">{{ news.tb_type_title }}</div>
          </div>
        </div>
        <el-pagination
          style="width: 100%; margin-top: 10px;"
          background
          layout="prev, pager, next"
          :page-size="newsParams.limit"
          :total="newsParams.total"
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @current-change="newsChange"
        />
      </div>
    </div>

    <div class="box_102" style="width: 1220px; margin: 10px auto;">
      <div style="position: relative;">
        <div
          style="text-align: left;width: 360px;height: 101px;font-family: FZLanTingHei-B-GBK;font-weight: 400;font-size: 100px;color: #F35022;opacity: 0.16;margin-left: -8px;"
        >
          Pickup
        </div>
        <div
          style="width: 100%; display: flex; justify-content: space-between; align-items: center; position: absolute;bottom: -10px;"
        >
          <h1>学校快搜</h1>
        </div>
      </div>
      <div class="Pickups-box">
        <div class="Pickups">
          <div
            v-for="(Pickup, index) in pickupList"
            :key="index"
            class="Pickup buts"
            @click="browse(Pickup.tb_school_uuid)"
          >
            <img
              style="width: 100%; height: 100%; border-radius: 15px;"
              :src="'api' + Pickup.tb_school_img"
              alt=""
            />
          </div>
        </div>
        <!-- <el-pagination
          style="width: 100%; margin-top: 10px;"
          background
          layout="prev, pager, next"
          :page-size="pickup.limit"
          :total="pickup.total"
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @current-change="pickupChange"
        /> -->
      </div>
    </div>

    <div class="box_102" style="width: 1220px; margin:20px auto 40px;">
      <div style="position: relative;">
        <div
          style="text-align: left;width: 360px;height: 101px;font-family: FZLanTingHei-B-GBK;font-weight: 400;font-size: 100px;color: #F35022;opacity: 0.16;"
        >
          Link
        </div>
        <div
          style="width: 100%; display: flex; justify-content: space-between; align-items: center; position: absolute;bottom: -10px;"
        >
          <h1>友情链接</h1>
        </div>
      </div>
      <div
        style="display: flex; align-content: center; justify-content: space-between; margin-top: 50px;"
      >
        <div
          class="custom-arrow buts"
          style="margin-top: 30px;"
          @click="LinkPrev"
        >
          <img
            class="custom-arrow buts"
            src="../assets/newImage/组 20.png"
            alt=""
          />
        </div>
        <el-carousel
          class="buts"
          ref="myCarouselTwo"
          style="flex: 1;"
          :interval="4000"
          height="88px"
          indicator-position="none"
          arrow="never"
          loop="false"
        >
          <el-carousel-item v-for="(item, index) in imglist" :key="item">
            <img
              style="box-shadow: 8px 8px 0 0 rgba(128, 187, 3, 1); border-radius: 10px;"
              class="imglj"
              :src="item.url1"
              alt=""
              @click="gotoxhs(item.name1)"
            />
            <img
              style="box-shadow: 8px 8px 0 0 rgba(128, 187, 3, 1); border-radius: 10px;"
              class="imglj"
              :src="item.url2"
              alt=""
              @click="gotoxhs(item.name2)"
            />
            <img
              style="box-shadow: 8px 8px 0 0 rgba(128, 187, 3, 1); border-radius: 10px;"
              class="imglj"
              :src="item.url3"
              alt=""
              @click="gotoxhs(item.name3)"
            />
          </el-carousel-item>
        </el-carousel>
        <div class="custom-arrow" style="margin-top: 30px;" @click="LinkNext">
          <img
            class="custom-arrow"
            src="../assets/newImage/组 20 (1).png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="box_102 group_54 flex-col">
      <my_article></my_article>
      <my-footer class="navbarone"></my-footer>
    </div>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <video
        style="width:100%;height:100%"
        :src="videoSrc"
        controls="controls"
        autoplay
        ref="videoL"
      >
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog>
  </div>
</template>

<script>
import navbar from "../components/navbar/navbar.vue";
import footer from "../components/footer/footer.vue";
import article from "../components/article/article.vue";
import { GetIndex, GeRmAddress, getLifeRotationChart } from "../api/index";
import { GetSchool } from "../api/school";
import { GetSchoolCha, GetPickupSchool } from "../api/schoolcha";
import { GetWenzhang } from "../api/wenzhang";
import { wenzhangtitle } from "../api/wenzhangone";
import { GetGuanyu } from "../api/guanyu";
import VirtualList from "../components/VirtualList/index.vue";
import { getmeunclasslist } from "../api/index";
export default {
  components: {
    "my-navbar": navbar,
    "my-footer": footer,
    my_article: article,
    VirtualList
  },
  data() {
    return {
      shipinList: [],
      slickOptions: {
        slidesToShow: 1
      },
      list: Array(5)
        .fill()
        .map((_, i) => `/src/assets/logo.png`),
      loopData0: [],
      huatixxList: [],
      schoolType: [
        // {
        //   label: "日语学校",
        //   value: 1,
        //   color: "#F35022"
        // },
        // {
        //   label: "专门学校",
        //   value: 2,
        //   color: "#03A5F0"
        // },
        // {
        //   label: "大学",
        //   value: 3,
        //   color: "#FFB903"
        // },
        // {
        //   label: "高中",
        //   value: 4,
        //   color: "#80BB03"
        // }
      ],
      newType: [
        {
          label: "所有新闻",
          value: null
        }
      ],
      rmdqList: [],
      dqList: [], //地区
      tsList: [], //特色
      csList: [], //城市
      school_id: "", //学校详情ID
      lxzxList: [],
      sjlist: [],
      input: "",
      dialogVisible: false,
      videoSrc: "",
      kb_content: "", //搜索
      currentNav: "", // 跟踪当前菜单
      trap: "1",
      num: 0,
      left: 0,
      gaunyuList: {},
      yjlist: [],
      CarouselChart: [],
      count: 0, //总数
      props: { multiple: true, checkStrictly: true },
      pickup: { page: 1, limit: 0, total: 0 },
      pickupList: [],
      newsParams: {
        page: 1,
        limit: 5,
        total: 0,
        tb_sign: 2,
        tb_type_title: null,
        tb_tuiguang: 0
      },
      hotNewsParams: {
        page: 1,
        limit: 0,
        tb_sign: 2,
        tb_type_title: null,
        tb_tuiguang: 1
      },
      newsList: [],
      hotNewsList: [],
      imglist: [
        {
          url1: require("@/assets/img/lj1.png"),
          name1: "https://www.kif-org.com",
          url2: require("@/assets/img/lj2.png"),
          name2: "https://www.jasso.go.jp",
          url3: require("@/assets/img/lj3.png"),
          name3: "https://www.jasso.go.jp/ryugaku/eju/index.html"
        },
        // {
        //  url4: require("@/assets/img/lj4.png"),
        // name4: "https://www.jlpt.jp/index.html"
        // },
        {
          url1: require("@/assets/img/lj5.png"),
          name1: "https://www.moj.go.jp/isa/about/region/tokyo/index.html",
          url2: require("@/assets/img/lj6.png"),
          name2: "http://jp.china-embassy.gov.cn/jpn/",
          url3: require("@/assets/img/lj7.png"),
          name3: "https://www.nhk.or.jp/lesson/ja/"
        },
        {
          url1: require("@/assets/img/lj1.png"),
          name1: "https://www.kif-org.com",
          url2: require("@/assets/img/lj2.png"),
          name2: "https://www.jasso.go.jp",
          url3: require("@/assets/img/lj3.png"),
          name3: "https://www.jasso.go.jp/ryugaku/eju/index.html"
        },
        // {
        //  url4: require("@/assets/img/lj4.png"),
        // name4: "https://www.jlpt.jp/index.html"
        // },
        {
          url1: require("@/assets/img/lj5.png"),
          name1: "https://www.moj.go.jp/isa/about/region/tokyo/index.html",
          url2: require("@/assets/img/lj6.png"),
          name2: "http://jp.china-embassy.gov.cn/jpn/",
          url3: require("@/assets/img/lj7.png"),
          name3: "https://www.nhk.or.jp/lesson/ja/"
        }
      ],
      dd: [],
      colorClasses: ["tag-red", "tag-blue", "tag-yellow", "tag-green"],
      newColorClasses: ["tag-red2", "tag-blue2", "tag-yellow2", "tag-green2"],
      activeIndex: 0,
      left: 0, // 当前 translateX
      currentIndex: 0, // 当前移动了多少个 item
      itemWidth: 253, // 每个卡片宽度(228px + gap约25px) 按你结构来的
      isTransition: true,
      autoTimer: null,
      autoInterval: 1500
    };
  },
  created() {
    this.getList();
    this.getguanyu();
    this.getschoolcha();
    this.getLifeRotation();
    this.GetPickupSchoolList();
    this.getNewsList();
    this.getNewsType();
    this.getHotNewsList();
    this.getSchoolClassList();
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  mounted() {
    this.startAutoPlay();
  },
  computed: {
    doubledData() {
      return [...this.shipinList, ...this.shipinList];
    },
    containerStyle() {
      return {
        overflow: "hidden",
        position: "relative",
        height:
          this.direction === "vertical" ? this.height + "px" : this.size + "px",
        width: this.direction === "horizontal" ? this.width + "px" : "100%"
      };
    },
    contentStyle() {
      return {
        animationPlayState: this.isPaused ? "paused" : "running",
        animationDuration: this.duration + "s"
      };
    },
    itemStyle() {
      return this.direction === "vertical"
        ? {
            height: this.size + "px",
            lineHeight: this.size + "px"
          }
        : {
            width: this.size + "px",
            height: "100%"
          };
    }
  },
  beforeUnmount() {
    clearInterval(this.autoTimer);
  },
  methods: {
    handleCarouselChange(index) {
      this.activeIndex = index;
    },
    processIndex(index, activeIndex, length) {
      const lastItemIndex = length - 1;
      const prevItemIndex = activeIndex - 1;
      const nextItemIndex = activeIndex + 1;
      const halfItemIndex = length / 2;

      if (activeIndex === 0 && index === lastItemIndex) {
        return -1;
      } else if (activeIndex === lastItemIndex && index === 0) {
        return length;
      } else if (
        index < prevItemIndex &&
        activeIndex - index >= halfItemIndex
      ) {
        return length + 1;
      } else if (
        index > nextItemIndex &&
        index - activeIndex >= halfItemIndex
      ) {
        return -2;
      }
      return index;
    },
    computeTranslate(idx) {
      const index = this.processIndex(
        idx,
        this.activeIndex,
        this.CarouselChart.length
      );

      const inStage = Math.round(Math.abs(index - this.activeIndex)) <= 1;
      const parentWidth = 1920; // 容器宽度

      if (inStage) {
        return (parentWidth * ((2 - 1) * (index - this.activeIndex) + 1)) / 3;
      } else if (index < this.activeIndex) {
        return (-(1 + 1) * parentWidth) / 3;
      } else {
        return ((3 + 1) * parentWidth) / 3;
      }
    },
    getItemStyle(index) {
      const offset = this.computeTranslate(index);
      console.log(offset, "==============");
      return {
        transform: [`translateX(${offset}px) scale(1)`]
      };
    },
    getTagClass(index) {
      // 可以改成随机分配，或者按index循环
      return this.colorClasses[index % this.colorClasses.length];
    },
    getNewTagClass(index) {
      // 可以改成随机分配，或者按index循环
      return this.newColorClasses[index % this.newColorClasses.length];
    },

    getLifeRotation() {
      getLifeRotationChart({
        page: this.page,
        limit: this.limit,
        purpose: 2
      }).then(res => {
        this.CarouselChart = res.data.data;
      });
    },

    gotoxhs(name) {
      window.open(name);
    },
    demo() {
      setTimeout(() => {
        // 未选择过数据,默认展开第一行数据
        let data = this.$refs.cascader.menus;
        let child1 = data[0][3].children;
        let child2 = child1[0].children;
        let child3 = child2[0].children;
        let arr = [];

        data[0] && arr.push(data[0]);
        child1 && arr.push(child1);
        child2 && arr.push(child2);
        child3 && arr.push(child3);
        this.$refs.cascader.menus = arr;
      }, 10);
    },
    toSchoolClass(tb_class_id) {
      this.$router.push({
        path: "/schoolCommon",
        query: { tb_class_id }
      });
    },
    getschoolcha() {
      GetSchoolCha({}).then(response => {
        this.count = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
      });
    },
    looook() {
      // let chooseArr = this.$refs.meauTree.getCheckedNodes();
      this.$router.push({
        name: "schoolCommon",
        params: {
          diqu: this.dd
        }
      });
    },
    bofang(item) {
      this.dialogVisible = true;
      this.videoSrc = item;
    },
    handleClose(done) {
      this.$nextTick(() => {
        const videoL = this.$refs.videoL;
        videoL.pause();
      });
      done();
    },
    pickupChange(value) {
      this.pickup.page = value;
      this.GetPickupSchoolList();
    },
    changeNewsType(value) {
      this.newsParams.page = 1;
      this.newsParams.tb_type_title = value;
      this.getNewsList();
    },
    changeHotNewsType(value) {
      this.hotNewsParams.tb_type_title = value;
      this.getHotNewsList();
    },
    newsChange(value) {
      this.newsParams.page = value;
      this.getNewsList();
    },
    //首页接口
    getList() {
      GetIndex().then(response => {
        this.sjlist = response.data.address_sj_data;
        // let sjarr = this.sjlist.map(item => {
        //   return {
        //     code: item.tb_address_code.toString().slice(0, 3),
        //     label: item.tb_address_name,
        //     value: item.tb_address_code
        //   };
        // });
        this.tsList = response.data.hxts_data; //特色
        this.csList = response.data.address_sj_data; //城市

        // this.lxzxList = response.data.lxzx_data; //留学资讯
        this.loopData0 = response.data.tglxzx_data; //留学资讯
        this.rmdqList = response.data.hxts_rm_data; //热门关键词
        this.shipinList = response.data.shiping_data;
        // this.shipinList = this.splitArray(response.data.shiping_data, 5); //视频
      });
      GetSchool({ page: 1, limit: 0 }).then(response => {
        this.huatixxList = response.data.data; //话题
      });
      GeRmAddress({ rm: true }).then(response => {
        this.dqList = response.data; //城市
      });
      GeRmAddress({ is_tree: true }).then(response => {
        this.yjlist = JSON.parse(JSON.stringify(response.data)); //城市
        this.demo();
      });
    },

    // 分割数据
    splitArray(arr, size) {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },
    getMapAddList(id, reserveArr = []) {
      if (reserveArr.length)
        return this.yjlist
          .find(item => item.id === id)
          .children.filter(item => reserveArr.includes(item.id))
          .map(item => {
            return {
              ...item,
              label: item.label.replace(/[县市]/g, "")
            };
          });
      return this.yjlist
        .find(item => item.id === id)
        .children.map(item => {
          return {
            ...item,
            label: item.label.replace(/[县市]/g, "")
          };
        });
    },

    async GetPickupSchoolList() {
      const res = await GetPickupSchool(this.pickup);
      this.pickupList = res.data.data;
      this.pickup.total = res.data.count;
    },

    //视频文字跳转学校详情
    details(id) {
      this.$router.push({
        path: "/schooldetails",
        query: { id }
      });
    },
    //话题浏览
    browse(id) {
      this.$router.push({
        path: "/schooldetails",
        query: { id }
      });
    },
    //地图框
    district(i, j) {
      // console.log(i);
      // return console.log(i, j, this.yjlist);
      this.$router.push({
        path: "/schoolCommon",
        query: { address_value: i, sub_id: j }
      });
    },
    //留学资讯
    information(id) {
      // console.log(id);
      let link = this.$router.resolve({
        path: "/study",
        query: { studyid: id }
      });
      window.open(link.href, "_blank");
      // this.$router.push({
      //   path: "/study",
      //   query: { studyid: id }
      // });
    },
    //搜索
    search(kb_content) {
      this.$router.push({
        path: "/schoolCommon",
        query: { keywords: kb_content }
      });
    },
    //跳转地区
    address(trap, val) {
      // this.$router.push('/page/schoolCommon');
      if (trap == 1) {
        this.$router.push({
          name: "schoolCommon",
          query: {
            toschool: val.tb_address_code,
            diqu: "地区"
          }
        });
      } else if (trap == 2) {
        this.$router.push({
          name: "schoolCommon",
          query: {
            characteristic: val.tb_school_uuid,
            teg_key: "特色"
          }
        });
      }
    },
    async getNewsType() {
      const res = await wenzhangtitle({ tb_sign: 2 });
      res.data.forEach(item => {
        item["label"] = item.tb_type_title;
        item["value"] = item.tb_type_title;
      });
      this.newType.push(...res.data);
    },

    // 获取资讯详情
    getzxxq(uuid) {
      this.$router.push({
        path: "/study",
        query: {
          studyid: uuid
        }
      });
    },
    // 单个自动轮播（每次移动一个）
    startAutoPlay() {
      this.autoTimer = setInterval(() => {
        this.moveOne();
      }, this.autoInterval);
    },

    stopAutoPlay() {
      clearInterval(this.autoTimer);
      this.autoTimer = null;
    },

    moveOne() {
      const total = this.shipinList.length;

      this.isTransition = true;
      this.currentIndex++;
      this.left = -this.currentIndex * this.itemWidth;

      // ⚠️ 关键：走到「第一份数据的末尾」时
      if (this.currentIndex === total) {
        // 等动画走完
        setTimeout(() => {
          this.isTransition = false; // 关闭动画
          this.currentIndex = 0;
          this.left = 0; // 瞬间跳回起点
        }, 600); // 必须等于 transition 时间
      }
    },

    prev() {
      this.stopAutoPlay();

      this.isTransition = true;
      this.currentIndex -= 5;

      if (this.currentIndex < 0) {
        this.currentIndex = 0;
      }

      this.left = -this.currentIndex * this.itemWidth;
      this.startAutoPlay();
    },

    next() {
      this.stopAutoPlay();

      const total = this.shipinList.length;
      this.isTransition = true;
      this.currentIndex += 5;

      if (this.currentIndex >= total) {
        this.currentIndex = total;
      }

      this.left = -this.currentIndex * this.itemWidth;
      this.startAutoPlay();
    },

    LinkPrev() {
      this.$refs.myCarouselTwo.prev();
    },
    LinkNext() {
      this.$refs.myCarouselTwo.next();
    },
    getguanyu() {
      GetGuanyu().then(response => {
        this.gaunyuList = response.data;
      });
    },
    async getNewsList() {
      const res = await GetWenzhang(this.newsParams);
      this.newsList = res.data.date;
      this.newsParams.total = res.data.count;
    },
    async getHotNewsList() {
      const res = await GetWenzhang(this.hotNewsParams);
      this.hotNewsList = res.data.date;
      console.log(this.hotNewsList, "1111111111==========================");
      this.hotNewsParams.total = res.data.count;
    },
    async getSchoolClassList() {
      const res = await getmeunclasslist();
      this.schoolType = res.data || [];
      console.log(res.data, "====================");
    }
  }
};
</script>
<style src="../../static/css/index.css" scoped />

<style scoped>
.article {
  display: flex;
  justify-content: center;
}
.imglj {
  width: 320px;
  height: 80px;
  margin: 0 20px;
}
.link {
  display: flex;
  justify-content: center;
}
.elem {
  /* margin-left: -863px;
  margin-top: 30px; */
  /* cursor: pointer; */
}
.buts {
  cursor: pointer;
}
/deep/ .el-cascader-menu__wrap {
  height: 400px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.ping {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.lunbo {
  display: flex;
  align-items: center;
  gap: 30px;
  width: 1380px;
  margin: 0 auto;
  overflow: hidden;
}

.custom-arrow {
  width: 32px;
  height: 32px;
  visibility: hidden;
}

.left {
  width: 58px;
  height: 180px;
  font-size: 28px;
  color: rgba(255, 255, 255, 0.5);
  background-color: rgba(85, 83, 83, 0.104);
  text-align: center;
  line-height: 180px;
}
.left:hover {
  background-color: rgba(85, 83, 83, 0.404);
  color: #fff;
}
.rigth {
  width: 58px;
  height: 180px;
  font-size: 28px;
  color: rgba(255, 255, 255, 0.5);
  background-color: rgba(85, 83, 83, 0.104);
  text-align: center;
  line-height: 180px;
}
.rigth:hover {
  background-color: rgba(85, 83, 83, 0.404);
  color: #fff;
}
/* .carousel-track {
  display: flex;
  gap: 25px;
  transition: transform 0.5s ease;
} */

.carousel-track > div {
  transition: transform 0.6s ease-in-out;
}
.carousel-track:hover > div {
  cursor: pointer;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff00;
}
/* ::v-deep .el-dialog__header ,.el-dialog__title{
  background-color: transparent;
  height: 100%;
}
::v-deep .el-dialog__headerbtn{
  position: absolute;
  top: 55px;
  right: 605px;
  font-size: 24px;
} */
</style>



// WEBPACK FOOTER //
// src/page/index.vue